import Dropdown from 'semantic-ui-react/dist/commonjs/modules/Dropdown';
import '@purple/semantic-ui-purple-theme/components/dropdown.css';

export default Dropdown;
